import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { type, colors, space } from '../theme';
import Chip from './Chip';

const EVIDENCE_VARIANT = {
  Explicit: 'success',
  Implied:  'warning',
  Possible: 'neutral',
};

// Spec §8.12 — page-3 full match card: the problem once, each supporting
// quote with its evidence chip, then the offering chips.
const FullMatchCard = ({ match }) => (
  <View wrap={false} style={{
    flexDirection: 'row',
    backgroundColor: '#ffffff',
    borderRadius: 6,
    borderWidth: 0.6,
    borderColor: colors.hair,
    overflow: 'hidden',
    marginBottom: space.md,
  }}>
    <View style={{ width: 4, backgroundColor: colors.teal }} />
    <View style={{ flex: 1, padding: space.lg }}>
      <Text style={[type.cardTitle, { color: colors.ink }]}>{match.title}</Text>

      {(match.quotes || []).map((q, qi) => (
        <View key={qi} style={{
          flexDirection: 'row',
          marginTop: space.md,
          backgroundColor: colors.tealPale,
          borderRadius: 4,
          padding: space.md,
        }}>
          <View style={{ width: 3, backgroundColor: colors.teal, marginRight: space.md, borderRadius: 2 }} />
          <View style={{ flex: 1 }}>
            <Text style={[type.body, { color: colors.ink, fontStyle: 'italic', fontWeight: 500 }]}>
              &ldquo;{q.text}&rdquo;
            </Text>
            {(q.attribution || q.evidence) && (
              <View style={{ flexDirection: 'row', alignItems: 'center', marginTop: 6, gap: 8 }}>
                {q.attribution && (
                  <Text style={[type.caption, { color: colors.teal, fontWeight: 700, letterSpacing: 0.3 }]}>
                    — {q.attribution}
                  </Text>
                )}
                {q.evidence && (
                  <Chip variant={EVIDENCE_VARIANT[q.evidence] || 'neutral'}>{q.evidence}</Chip>
                )}
              </View>
            )}
          </View>
        </View>
      ))}

      {(match.offerings || []).length > 0 && (
        <View style={{ flexDirection: 'row', flexWrap: 'wrap', marginTop: space.md, gap: 6 }}>
          {match.offerings.map((o, i) => (
            <Chip key={i}>{o}</Chip>
          ))}
        </View>
      )}
    </View>
  </View>
);

export default FullMatchCard;
